(function() {
  var $2ae77e371e969ed9$export$2e2bcd8739ae039 = (() => {
    if (customElements.get("copyable-text")) return;
    customElements.define("copyable-text", class CopyableText extends HTMLElement {
      constructor() {
        super();
        this.label = this.querySelector("[data-copyable-label]");
        this.success = this.querySelector("[data-copyable-success]");
        this.resetTimeout = null;
        this.handleActivate = this.handleActivate.bind(this);
      }
      connectedCallback() {
        this.addEventListener("click", this.handleActivate);
        this.addEventListener("keydown", this.handleActivate);
      }
      disconnectedCallback() {
        this.removeEventListener("click", this.handleActivate);
        this.removeEventListener("keydown", this.handleActivate);
        this.clearReset();
      }
      handleActivate(e) {
        if (e instanceof KeyboardEvent && e.key !== "Enter" && e.key !== " ") return;
        this.copy();
      }
      copy() {
        const text = this.dataset.text;
        if (!text) return;
        if (navigator.clipboard) navigator.clipboard.writeText(text).then(() => this.showSuccess()); else {
          const el = document.createElement("textarea");
          el.value = text;
          el.style.cssText = "position:fixed;opacity:0;pointer-events:none";
          document.body.appendChild(el);
          el.select();
          document.execCommand("copy");
          document.body.removeChild(el);
          this.showSuccess();
        }
      }
      showSuccess() {
        this.clearReset();
        this.label?.classList.add("hidden");
        this.success?.classList.remove("hidden");
        this.setAttribute("aria-label", "Copied");
        this.resetTimeout = setTimeout(() => this.reset(), 2e3);
      }
      reset() {
        this.label?.classList.remove("hidden");
        this.success?.classList.add("hidden");
        const text = this.dataset.text;
        if (text) this.setAttribute("aria-label", `Copy ${text}`);
      }
      clearReset() {
        if (!this.resetTimeout) return;
        clearTimeout(this.resetTimeout);
        this.resetTimeout = null;
      }
    });
  })();
})();